/* eslint-disable */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Users, Lock, FileText, Unlock, X, Printer } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const $ = (v) => `$${Number(v || 0).toFixed(2)}`;

const Report = ({ r, onClose }) => (
  <div className="fixed inset-0 z-[130] bg-black/80 flex items-center justify-center p-4" onClick={onClose} data-testid="inv-report-modal">
    <div className="bg-white rounded-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto p-6 text-zinc-900" onClick={(e) => e.stopPropagation()}>
      <div className="flex items-center justify-between mb-4">
        <div><p className="font-black text-xl">Rapport d'investissement — {r.name}</p>
          <p className="text-zinc-500 text-xs">Code {r.code} · {String(r.country || "").toUpperCase()} · Clôturé le {new Date(r.closed_at || r.created_at).toLocaleString("fr-FR")}</p></div>
        <div className="flex gap-2">
          <button onClick={() => window.print()} className="p-2 rounded-lg bg-zinc-100 hover:bg-zinc-200" data-testid="inv-report-print"><Printer className="w-4 h-4" /></button>
          <button onClick={onClose} className="p-2 rounded-lg bg-zinc-100 hover:bg-zinc-200" data-testid="inv-report-close"><X className="w-4 h-4" /></button>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2 mb-4">
        {[["Investi", $(r.investment_amount)], ["Revenus", $(r.control.revenue)], ["Commissions+bonus", $(r.control.commissions)], ["Net", $(r.control.net)], ["ROI", `${r.control.roi_pct}%`], ["Payé à l'INV", $(r.total_paid_out)]].map(([k, v]) => (
          <div key={k} className="bg-zinc-100 rounded-xl p-3"><p className="text-zinc-500 text-[10px] uppercase font-black">{k}</p><p className="font-black text-lg">{v}</p></div>
        ))}
      </div>
      <table className="w-full text-sm">
        <thead><tr className="text-left text-zinc-500 text-[11px] uppercase"><th>Personne</th><th>Rôle</th><th>Vendus</th><th>Restant</th><th>Revenus</th></tr></thead>
        <tbody>{r.people.map((p) => <tr key={p.id} className="border-t border-zinc-200"><td className="py-1.5 font-bold">{p.name} <span className="text-zinc-400 text-xs">{p.code}</span></td><td>{p.role}</td><td>{p.sold}</td><td>{p.current_stock}</td><td>{$(p.total_revenue)}</td></tr>)}</tbody>
      </table>
      {r.note && <p className="mt-3 text-sm text-zinc-700">Note : {r.note}</p>}
    </div>
  </div>
);

const InvCard = ({ inv, users, reload, openReport }) => {
  const [pick, setPick] = useState("");
  const closed = inv.status === "closed";
  const link = async (user_id, action) => {
    try { await axios.post(`${API}/ceo/finance/investments/${inv.id}/link`, { user_id, action }); reload(); } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
  };
  const close = async () => {
    const note = window.prompt(`Clôturer l'investissement de ${inv.name} ? Note pour le rapport (optionnel) :`, "");
    if (note === null) return;
    try { const r = await axios.post(`${API}/ceo/finance/investments/${inv.id}/close`, { note }); toast.success("Investissement clôturé — rapport produit"); reload(); openReport(r.data); }
    catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
  };
  const lastReport = async () => {
    const r = await axios.get(`${API}/ceo/finance/investments/${inv.id}/reports`);
    if (!r.data.items.length) return toast.info("Aucun rapport — clôturez d'abord l'investissement");
    openReport(r.data.items[0]);
  };
  const reopen = async () => { await axios.post(`${API}/ceo/finance/investments/${inv.id}/reopen`); reload(); };
  const c = inv.control;
  return (
    <div className={`rounded-2xl p-4 border-2 ${closed ? "border-zinc-600 bg-zinc-900/60" : "border-emerald-500/40 bg-zinc-900"}`} data-testid={`inv-card-${inv.id}`}>
      <div className="flex items-center gap-3 flex-wrap mb-3">
        <div className="flex-1 min-w-[160px]">
          <p className="text-white font-black">{inv.name} <span className="text-zinc-400 text-xs font-normal">· {inv.code} · {String(inv.country || "").toUpperCase()}</span></p>
          <p className={`text-[11px] font-black uppercase ${closed ? "text-zinc-400" : "text-emerald-400"}`} data-testid={`inv-status-${inv.id}`}>{closed ? `Clôturé le ${new Date(inv.closed_at).toLocaleDateString("fr-FR")}` : "En cours"}</p>
        </div>
        <button onClick={lastReport} className="text-xs font-bold bg-zinc-800 hover:bg-zinc-700 text-amber-400 px-3 py-2 rounded-lg flex items-center gap-1" data-testid={`inv-report-btn-${inv.id}`}><FileText className="w-3.5 h-3.5" />Rapport</button>
        {closed ? <button onClick={reopen} className="text-xs font-bold bg-zinc-700 text-white px-3 py-2 rounded-lg flex items-center gap-1" data-testid={`inv-reopen-${inv.id}`}><Unlock className="w-3.5 h-3.5" />Rouvrir</button>
          : <button onClick={close} className="text-xs font-black bg-red-600 hover:bg-red-500 text-white px-3 py-2 rounded-lg flex items-center gap-1" data-testid={`inv-close-${inv.id}`}><Lock className="w-3.5 h-3.5" />Clôturer</button>}
      </div>
      <div className="grid grid-cols-3 md:grid-cols-6 gap-2 mb-3">
        {[["Investi", $(inv.investment_amount)], ["Vendus", c.units_sold], ["Restant", c.units_left], ["Revenus", $(c.revenue)], ["Net", $(c.net)], ["ROI", `${c.roi_pct}%`]].map(([k, v]) => (
          <div key={k} className="bg-black/40 rounded-lg p-2"><p className="text-zinc-400 text-[9px] uppercase font-black">{k}</p><p className="text-white font-black text-sm">{v}</p></div>
        ))}
      </div>
      <p className="text-zinc-400 text-[10px] font-black uppercase mb-1.5 flex items-center gap-1"><Users className="w-3 h-3" /> Personnes liées ({inv.people.length})</p>
      <div className="flex flex-wrap gap-2 mb-2">
        {inv.people.map((p) => (
          <span key={p.id} className="bg-zinc-800 text-white text-xs rounded-lg px-2 py-1 flex items-center gap-2" data-testid={`inv-person-${p.id}`}>
            {p.name} <span className="text-zinc-400">{p.role} · {p.sold}/{p.initial_stock}</span>
            {!closed && <button onClick={() => link(p.id, "remove")} className="text-red-400 hover:text-red-300"><X className="w-3 h-3" /></button>}
          </span>
        ))}
        {!inv.people.length && <span className="text-zinc-500 text-xs">Aucune personne liée.</span>}
      </div>
      {!closed && (
        <div className="flex gap-2">
          <select value={pick} onChange={(e) => setPick(e.target.value)} className="flex-1 bg-zinc-950 border border-zinc-700 rounded-lg px-2 py-1.5 text-white text-xs" data-testid={`inv-link-select-${inv.id}`}>
            <option value="">+ Lier un stocker / NM…</option>
            {users.filter((u) => !inv.people.some((p) => p.id === u.id)).map((u) => <option key={u.id} value={u.id}>{u.name} · {u.code} ({u.r})</option>)}
          </select>
          <button disabled={!pick} onClick={() => { link(pick, "add"); setPick(""); }} className="bg-emerald-600 disabled:opacity-40 text-white text-xs font-black px-3 rounded-lg" data-testid={`inv-link-add-${inv.id}`}>Lier</button>
        </div>
      )}
    </div>
  );
};

export const FinanceInvestments = () => {
  const [items, setItems] = useState([]); const [users, setUsers] = useState([]); const [report, setReport] = useState(null);
  const load = () => axios.get(`${API}/ceo/finance/investments`).then((r) => setItems(r.data.items || [])).catch(() => {});
  useEffect(() => {
    load();
    Promise.all([axios.get(`${API}/stockers`), axios.get(`${API}/network-marketers`)]).then(([a, b]) => {
      const s = Array.isArray(a.data) ? a.data : a.data.stockers || []; const n = Array.isArray(b.data) ? b.data : b.data.marketers || b.data.network_marketers || [];
      setUsers([...s.map((x) => ({ ...x, r: "Stocker" })), ...n.map((x) => ({ ...x, r: "NM" }))]);
    }).catch(() => {});
  }, []);
  return (
    <div className="glass-panel p-6" data-testid="finance-investments">
      <h3 className="text-white font-bold mb-4">💼 Investissements — personnes liées, contrôle, clôture & rapport</h3>
      <div className="space-y-3">
        {items.map((inv) => <InvCard key={inv.id} inv={inv} users={users} reload={load} openReport={setReport} />)}
        {!items.length && <p className="text-zinc-500 text-sm">Aucun investisseur.</p>}
      </div>
      {report && <Report r={report} onClose={() => setReport(null)} />}
    </div>
  );
};
